__turbopack_context__.v({
  "wrapper": "install-pwa-prompt-module-scss-module__Jvt4ZG__wrapper",
});
